<script setup lang="ts">
import { PV } from "@/widgets";
import { computed, ref, unref, type Component } from "vue";
import type { CreateDialog } from "../../common/button.common";

const props = defineProps<{
    controller: CreateDialog;
    label?: string;
    icon?: Component;
    severity?: "secondary" | "success" | "info" | "warn" | "help" | "danger" | "contrast";
}>();

defineSlots<{
    default: (data: { onClick: () => Promise<void> | void }) => any;
}>();

const dialogPopup = ref<{ toggle: (event: Event) => void }>();
const isLoading = computed(() => {
    return unref(props.controller.isLoading) === true;
});

function toggleDialogPopup(event: Event) {
    dialogPopup.value?.toggle(event);
}
</script>

<template>
    <PV.Button :disabled="isLoading" :severity="props.severity" type="button" @click="toggleDialogPopup">
        <span class="inline-flex flex-row items-center gap-1">
            <i v-if="isLoading" class="pi pi-spin pi-spinner mr-1" style="font-size: 1rem" />
            <component :is="props.icon" v-if="props.icon !== undefined" />
            <span class="font-medium">{{ props.label ?? "Simpan" }}</span>
        </span>
    </PV.Button>

    <PV.Popover ref="dialogPopup">
        <div class="flex flex-col gap-3">
            <slot name="default" :onClick="props.controller.onClick"></slot>
        </div>
    </PV.Popover>
</template>
